import { Backend } from '../../../api/Backend';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { ListFilters } from '../../../pages/content/listPage/ListFilters';

const Constants = {
  filters: [listFilterType.day, listFilterType.tag],
};

export class EpgGuideFilterDataSource {
  private readonly backend: Backend;
  state: FilterState | undefined;
  private pastAndFuture: boolean;
  constructor(backend: Backend) {
    this.backend = backend;
    this.pastAndFuture = true;
  }

  componentDescription() {
    return {
      focusable: true,
      type: ListFilters,
      data: this,
      filterState: this.state,
      backend: this.backend,
    };
  }

  load(): Promise<EpgGuideFilterDataSource> {
    return new Promise(resolve => {
      this.state = new FilterState();
      Constants.filters.forEach(filter => {
        this.state?.add(filter);
      });
      resolve(this);
    });
  }

  isEmpty(): boolean {
    return false;
  }

  height(): number {
    return 60;
  }
}
